import {
  START_FETCHING_FAVORITES,
  FINISH_FETCHING_FAVORITES,
  SET_FAVORITES_ORDER,
  CLEAR_FAVORITES,
  CLEAR_FAVORITES_ORDER
} from '../../actions/favorite'

let defaultState = {
  loading: false,
  total: 0,
  page: 1,
  orderInfo: {}
}

const favorites = (state = defaultState, action) => {
  switch (action.type) {
    case START_FETCHING_FAVORITES:
      return {
        ...state,
        loading: true
      }
    case FINISH_FETCHING_FAVORITES:
      return {
        ...state,
        loading: false,
        total: action.total,
        page: state.page + 1
      }
    case CLEAR_FAVORITES_ORDER:
      return {
        ...state,
        orderInfo: {}
      }
    case SET_FAVORITES_ORDER:
      return {
        ...state,
        orderInfo: action.orderInfo
      }
    case CLEAR_FAVORITES:
      return {
        ...state,
        page: 1
      }
  }
  return state
}

export default favorites
